"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateAverageRating = calculateAverageRating;
exports.getTotalReviews = getTotalReviews;
exports.formatRating = formatRating;
exports.getRatingDistribution = getRatingDistribution;
/**
 * Calculate average rating from star counts
 * Performance: ~0.001ms for single calculation
 */
function calculateAverageRating(starCounts) {
    const totalRating = starCounts['1'] * 1 + starCounts['2'] * 2 + starCounts['3'] * 3 + starCounts['4'] * 4 + starCounts['5'] * 5;
    const totalReviews = starCounts['1'] + starCounts['2'] + starCounts['3'] + starCounts['4'] + starCounts['5'];
    return totalReviews > 0 ? Math.round((totalRating / totalReviews) * 100) / 100 : 0;
}
/**
 * Get total review count from star counts
 */
function getTotalReviews(starCounts) {
    return Object.values(starCounts).reduce((sum, count) => sum + count, 0);
}
/**
 * Format rating for display (e.g., "4.2" or "No ratings")
 */
function formatRating(starCounts) {
    const average = calculateAverageRating(starCounts);
    const total = getTotalReviews(starCounts);
    if (total === 0)
        return 'No ratings';
    return average.toFixed(1);
}
/**
 * Get rating distribution percentages
 */
function getRatingDistribution(starCounts) {
    const total = getTotalReviews(starCounts);
    if (total === 0)
        return { '1': 0, '2': 0, '3': 0, '4': 0, '5': 0 };
    return {
        '1': Math.round((starCounts['1'] / total) * 100),
        '2': Math.round((starCounts['2'] / total) * 100),
        '3': Math.round((starCounts['3'] / total) * 100),
        '4': Math.round((starCounts['4'] / total) * 100),
        '5': Math.round((starCounts['5'] / total) * 100),
    };
}
